import styled from 'styled-components'

export const CellStyle = styled.div<{
  shaded: boolean
  listType: boolean
}>`
  display: flex;
  flex-direction: column;
  text-align: ${(props) => (props.listType ? 'left' : 'center')};
  align-items: ${(props) => (props.listType ? 'flex-start' : 'center')};
  justify-content: center;
  color: ${(props) => props.theme.pcwCell?.textColor || '#000000'};
  background: ${(props) =>
    props.shaded
      ? '#DCDCDC'
      : props.theme.pcwCell?.backgroundColor || '#ffffff'};
  @media (max-width: 600px) {
    min-width: 180px;
    font-size: small;
    height: 78px;
  }
  min-width: 120px;
  height: 150px;
  border-radius: 17px;
  @media (max-width: 600px) {
    border: 1px solid;
    border-color: lightgray;
    border-radius: 0px;
  }
  word-wrap: break-word;
  font-weight: bolder;
  font-size: small;
`
